import React from 'react';
import TemplateThumbnail from './TemplateThumbnail';
import './TemplateTable.css';

function TemplateTable({
    templates,
    onEdit,
    onDuplicate,
    onDelete,
    onViewUsages,
    onViewVersions,
    loading,
    canUpdate = true,
    canDelete = true
}) {
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    return (
        <div className="template-table-container">
            <table className="template-table">
                <thead>
                    <tr>
                        <th className="table-preview-col">Aperçu</th>
                        <th className="table-name-col">Nom</th>
                        <th className="table-description-col">Description</th>
                        <th className="table-date-col">Créé le</th>
                        <th className="table-date-col">Modifié le</th>
                        <th className="table-creator-col">Créé par</th>
                        <th className="table-actions-col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {templates.length === 0 ? (
                        <tr>
                            <td colSpan="7" className="table-empty">
                                Aucun modèle trouvé
                            </td>
                        </tr>
                    ) : (
                        templates.map((template) => (
                            <tr
                                key={template.id}
                                className="table-row"
                            >
                                <td className="table-preview-col">
                                    <TemplateThumbnail
                                        templateId={template.id}
                                        uid={template.uid}
                                        updatedAt={template.updated_at}
                                        containerWidth={template.container_width}
                                        width={40}
                                        height={40}
                                        onClick={() => canUpdate ? onEdit(template.id) : onViewUsages(template.id)}
                                    />
                                </td>
                                <td className="table-name-col">
                                    <span
                                        className="table-name-link"
                                        onClick={() => canUpdate ? onEdit(template.id) : onViewUsages(template.id)}
                                    >
                                        {template.name}
                                    </span>
                                </td>
                                <td className="table-description-col">
                                    <span className="table-description">
                                        {template.description || '-'}
                                    </span>
                                </td>
                                <td className="table-date-col">
                                    {formatDate(template.created_at)}
                                </td>
                                <td className="table-date-col">
                                    {formatDate(template.updated_at)}
                                </td>
                                <td className="table-creator-col">
                                    {template.creator_first_name ? (
                                        <span className="table-creator">
                                            {template.is_owner ? 'Vous' : `${template.creator_first_name} ${template.creator_last_name || ''}`}
                                        </span>
                                    ) : '-'}
                                </td>
                                <td className="table-actions-col">
                                    <div className="table-actions">
                                        {canUpdate && (
                                            <button
                                                className="table-action-btn table-action-edit"
                                                onClick={() => onEdit(template.id)}
                                                title="Éditer"
                                                disabled={loading}
                                            >
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                                    />
                                                </svg>
                                            </button>
                                        )}
                                        {canUpdate && (
                                            <button
                                                className="table-action-btn table-action-duplicate"
                                                onClick={() => onDuplicate(template.id)}
                                                title="Dupliquer"
                                                disabled={loading}
                                            >
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                                                    />
                                                </svg>
                                            </button>
                                        )}
                                        <button
                                            className="table-action-btn table-action-versions"
                                            onClick={() => onViewVersions(template.id)}
                                            title="Voir les versions"
                                            disabled={loading}
                                        >
                                            <svg
                                                width="16"
                                                height="16"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                                />
                                            </svg>
                                        </button>
                                        <button
                                            className="table-action-btn table-action-usages"
                                            onClick={() => onViewUsages(template.id)}
                                            title="Voir les utilisations"
                                            disabled={loading}
                                        >
                                            <svg
                                                width="16"
                                                height="16"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                                />
                                            </svg>
                                        </button>
                                        {canDelete && (
                                            <button
                                                className="table-action-btn table-action-delete"
                                                onClick={() => onDelete(template.id)}
                                                title="Supprimer"
                                                disabled={loading}
                                            >
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                    />
                                                </svg>
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TemplateTable;
